document.addEventListener('DOMContentLoaded', () => {
  const menuOpen = document.querySelector('[data-rk-menu-open]');
  const menuClose = document.querySelector('[data-rk-menu-close]');
  const menuPanel = document.querySelector('[data-rk-mobile-panel]');
  const search = document.querySelector('[data-rk-search]');
  const searchOpeners = document.querySelectorAll('[data-rk-search-open]');
  const searchClosers = document.querySelectorAll('[data-rk-search-close]');
  const searchInput = document.querySelector('[data-rk-search-input]');
  const searchResults = document.querySelector('[data-rk-search-results]');
  const searchForm = document.querySelector('[data-rk-search-form]');

  const pageLock = (locked) => {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
  };

  const toggleMenu = (state) => {
    if (!menuPanel) return;
    menuPanel.classList.toggle('is-open', state);
    menuPanel.setAttribute('aria-hidden', state ? 'false' : 'true');
    pageLock(state || Boolean(search && search.classList.contains('is-open')));
  };

  const toggleSearch = (state) => {
    if (!search) return;
    search.classList.toggle('is-open', state);
    search.setAttribute('aria-hidden', state ? 'false' : 'true');
    searchOpeners.forEach((opener) => opener.setAttribute('aria-expanded', state ? 'true' : 'false'));
    if (state) {
      toggleMenu(false);
      window.setTimeout(() => searchInput && searchInput.focus(), 120);
    }
    pageLock(state || Boolean(menuPanel && menuPanel.classList.contains('is-open')));
  };

  menuOpen && menuOpen.addEventListener('click', () => toggleMenu(true));
  menuClose && menuClose.addEventListener('click', () => toggleMenu(false));
  menuPanel && menuPanel.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', () => toggleMenu(false)));
  searchOpeners.forEach((opener) => opener.addEventListener('click', () => toggleSearch(true)));
  searchClosers.forEach((closer) => closer.addEventListener('click', () => toggleSearch(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (search && search.classList.contains('is-open')) toggleSearch(false);
    if (menuPanel && menuPanel.classList.contains('is-open')) toggleMenu(false);
  });

  if (!searchInput || !searchResults) return;

  let searchTimer;
  let searchController;

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const renderProducts = (products, query) => {
    if (!products.length) {
      searchResults.innerHTML = `<div class="rk-search__empty">No encontramos productos para “${escapeHtml(query)}”.</div>`;
      return;
    }
    searchResults.innerHTML = products.map((product) => {
      const image = product.featured_image && product.featured_image.url
        ? `<img src="${escapeHtml(product.featured_image.url)}&width=220" alt="${escapeHtml(product.title)}" loading="lazy">`
        : '<span class="rk-search-card__placeholder"></span>';
      const url = product.url || '#';
      return `<a class="rk-search-card" href="${escapeHtml(url)}">
        <span class="rk-search-card__media">${image}</span>
        <span class="rk-search-card__copy"><strong>${escapeHtml(product.title)}</strong><small>Ver producto →</small></span>
      </a>`;
    }).join('');
  };

  const runSuggest = async (query) => {
    if (searchController) searchController.abort();
    searchController = new AbortController();
    searchResults.innerHTML = '<div class="rk-search__loading">Buscando...</div>';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show`;
    try {
      const response = await fetch(url, { signal: searchController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Search ${response.status}`);
      const data = await response.json();
      const products = data && data.resources && data.resources.results && data.resources.results.products
        ? data.resources.results.products
        : [];
      renderProducts(products, query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      searchResults.innerHTML = '<div class="rk-search__empty">No pudimos cargar las sugerencias. Presiona Enter para buscar.</div>';
    }
  };

  searchInput.addEventListener('input', () => {
    const query = searchInput.value.trim();
    window.clearTimeout(searchTimer);
    if (query.length < 2) {
      if (searchController) searchController.abort();
      searchResults.innerHTML = '';
      return;
    }
    searchTimer = window.setTimeout(() => runSuggest(query), 180);
  });

  searchForm && searchForm.addEventListener('submit', (event) => {
    if (!searchInput.value.trim()) event.preventDefault();
  });
});

/* RADIKAL product-page safe cleanup. This deliberately avoids changing Ella's product template. */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-product')) return;

  // Remove demo-only product metadata while keeping real stock availability.
  document.querySelectorAll('.productView-info-item').forEach((item) => {
    const label = (item.querySelector('.productView-info-name')?.textContent || '').trim().toLowerCase();
    if (/^(proveedor|vendor|sku|código de barras|codigo de barras|barcode|tipo|type)\s*:?$/.test(label)) {
      item.style.display = 'none';
    }
  });

  // Translate the only tab we keep from Ella's default product template.
  document.querySelectorAll('.productView-tab .tab-title, .productView-tab .toggleLink .text').forEach((el) => {
    const text = (el.textContent || '').trim().toLowerCase();
    if (text === 'description') el.textContent = 'Descripción';
  });

  // Rename related-products heading if it is present.
  document.querySelectorAll('.halo-product-block .halo-block-header .title .text').forEach((el) => {
    const text = (el.textContent || '').trim().toLowerCase();
    if (text === 'related products') el.textContent = 'También te puede gustar';
  });
});

/* RADIKAL v0.8: remove Ella Compare Color from the product experience. */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-product')) return;
  document.querySelectorAll('[data-open-compare-color-popup], [data-compare-color-popup], #halo-compare-color-popup').forEach((el) => el.remove());
});
